if (!customElements.get('free-gift')) {
  class FreeGift extends HTMLElement {
    constructor() {
      super();

      this.addToCartButtons = this.querySelectorAll('[data-gift-product-id]');
      this.threshold = this.getAttribute('data-gift-threshold') || 0;
      this.cartTotalPrice = parseFloat(this.getAttribute('data-total-price')) || 0;
      this.lockedGiftPicker = this.hasAttribute('data-locked-gift-picker');
      this.freeGifts = JSON.parse(this.getAttribute('data-available-free-products') || '[]');
      this.productsInCart = JSON.parse(this.getAttribute('data-products-in-cart') || '[]');

      if (!this.addToCartButtons.length) {
        return;
      }

      this.checkEligibility()

      this.init();
    }

    init() {
      this.addToCartButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          
          const variantId = button.getAttribute('data-gift-product-id');
          const sections = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

          const body = JSON.stringify({
            id: variantId,
            quantity: 1,
            sections: sections
          });

          fetch(theme.routes.cart_add_url, {...fetchConfig('javascript'), body })
            .then(response => response.json())
            .then(parsedState => {

              const miniCart  = document.querySelector('mini-cart');

              if (!miniCart) {
                return;
              }

              miniCart.renderContents(parsedState);

              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  cart: parsedState
                }
              }));


              console.log('Gift added to cart:', data);
              // Optionally, you can update the cart UI here
            })
            .catch(error => {
              console.error('Error adding gift to cart:', error);
            });
        });
      })
    }

    checkIfDeleteGift() {
      const currenctRate = Shopify.currency.rate || 1;
      const thresholdInCents = this.threshold * 100 * currenctRate;

      if (this.cartTotalPrice >= thresholdInCents) {
        return;
      }

      const addedGift = this.productsInCart.filter(productId => this.freeGifts.includes(productId));

      if (!addedGift.length) {
        return;
      }

      addedGift.forEach(giftId => {
        const lineItemIndex = this.productsInCart.findIndex(productId => productId === giftId);
        const sections = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

        if (lineItemIndex === -1) {
          return;
        }

        const body = JSON.stringify({
          line: lineItemIndex + 1,
          quantity: 0,
          sections: sections,
          sections_url: window.location.pathname
        });


        fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
          .then(response => response.json())
          .then(parsedState => {
            const miniCart  = document.querySelector('mini-cart');

            if (!miniCart) {
              return;
            }

            miniCart.renderContents(parsedState);

            document.dispatchEvent(new CustomEvent('ajaxProduct:removed', {
              detail: {
                cart: parsedState
              }
            }));
          })
      })
    }

    checkEligibility() {
      if (this.lockedGiftPicker) {
        this.classList.add('locked');
        this.checkIfDeleteGift();

        return;
      }


      const currenctRate = Shopify.currency.rate || 1;
      const thresholdInCents = this.threshold * 100 * currenctRate;

      if (this.cartTotalPrice >= thresholdInCents) {
        this.classList.remove('locked');
      } else {
        this.classList.add('locked');

        this.checkIfDeleteGift();
      }
    }
  }

  customElements.define('free-gift', FreeGift);
}

